import React from 'react'
import { Badge, NavItem } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { getFilteredEvents } from '../../store/events/selectors'

export const EventInfoBadges = () => {
  const events = useSelector(getFilteredEvents)
  const { list: registrations } = useSelector(
    (state: RootState) => state.registrations,
  )
  const { data: program } = useSelector((state: RootState) => state.program)
  return (
    <>
      <NavItem className='d-flex align-items-center flex-fill pt-2'>
        <Badge pill variant='info' className='mr-2 mobile-badge'>
          {events
            ? events.length > 1
              ? `${events.length} Veranstaltungen verfügbar`
              : `${events.length} Veranstaltung verfügbar`
            : 'Keine Veranstaltungen verfügbar'}
        </Badge>
      </NavItem>
      {program.requires_family_data && (
        <NavItem className='d-flex align-items-center flex-fill pt-2'>
          <Badge pill variant='info' className='mr-2 mobile-badge'>
            Familienanmeldung aktiv
          </Badge>
        </NavItem>
      )}
      {program.access_key_mode !== 'off' && (
        <NavItem className='d-flex align-items-center flex-fill pt-2'>
          <Badge pill variant='info' className='mr-2 mobile-badge'>
            {program.access_key_mode === 'req'
              ? 'Zugangscodes erforderlich'
              : 'Zugangscodes optional'}
          </Badge>
        </NavItem>
      )}
      {program.max_registrations_per_participant > 0 && (
        <NavItem className='d-flex align-items-center flex-fill pt-2'>
          <Badge pill variant='info' className='mr-2 mobile-badge'>
            {program.max_registrations_per_participant > 1
              ? `Maximal ${program.max_registrations_per_participant} Anmeldungen`
              : 'Maximal eine Anmeldung'}
          </Badge>
        </NavItem>
      )}
      {registrations.length ? (
        <NavItem className='d-flex align-items-center flex-fill pt-2'>
          <Badge pill variant='success' className='mr-2 mobile-badge'>
            Ausgewählte Veranstaltungen: {registrations.length}
          </Badge>
        </NavItem>
      ) : (
        ''
      )}
    </>
  )
}
